let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8gQKz"), load("1D6DH"), load("6zfzy"), load("6m2wP")]).then(() => parcelRequire('h3wNo'));